import { z } from "zod";
import { DeliveryStatus, OrderStatusEnum } from "./order.js";
import { createApiResponseSchema } from "./response.js";
const OrderListItemSchema = z.object({
  dboxnum: z.string(),
  ordkey: z.string(),
  dlvyno: z.number(),
  jobstatval: z.string(),
  // TODO: 만약 가능한 모든 값이 고정되어 있다면 enum으로 정의하는 것이 좋습니다.
  rokdt: z.string().nullable(),
  // 날짜/시간 형식의 문자열일 수 있습니다.
  ordstat: z.number(),
  // ORD_STAT의 값과 매칭될 수 있습니다. z.nativeEnum(ORD_STAT).optional() 등으로 검증 가능
  jobstat: z.number(),
  shipnum: z.string().nullable(),
  dlvystat: z.number(),
  dlvymcd: z.number(),
  dlvycomp: z.string().nullable().optional(),
  regdt: z.string(),
  // 날짜/시간 형식 문자열, 필요시 .datetime() 추가 검증
  ordno: z.number(),
  // 이전 요청의 ordnum(문자열)과 다름을 인지해야 합니다.
  totcnt: z.number(),
  dlvystatval: DeliveryStatus,
  // TODO: 이것도 enum 정의 고려
  ordtitle: z.string(),
  ordnum: z.string(),
  // 예: "WPABP2301121165"
  ordstatval: OrderStatusEnum
  // 정의된 Enum 사용
});
const PaginationInfoSchema = z.object({
  currentPageNo: z.number(),
  recordCountPerPage: z.number(),
  pageSize: z.number(),
  totalRecordCount: z.number(),
  totalPageCount: z.number(),
  firstPageNoOnPageList: z.number(),
  lastPageNoOnPageList: z.number(),
  firstRecordIndex: z.number(),
  lastRecordIndex: z.number(),
  lastPageNo: z.number(),
  firstPageNo: z.number()
});
const ConditionSchema = z.object({
  firstIndex: z.number(),
  recordCountPerPage: z.number(),
  lastIndex: z.number()
});
const OrdListSchema = z.object({
  ordlist: z.array(OrderListItemSchema),
  paginationInfo: PaginationInfoSchema,
  condition: ConditionSchema
});
const OrdListApiResponseSchema = createApiResponseSchema(OrdListSchema);
export {
  OrdListApiResponseSchema,
  OrdListSchema,
  OrderListItemSchema
};
//# sourceMappingURL=ordlist.js.map